/**
 * TopBar — the bar at the top of the public pages (landings, plans, logins). Replaces the old floating
 * white "← Back to Home" button that sat on top of the page content (Stage 3 polish, 1 Oct 2026).
 * Sticky: it takes its own space and stays visible while scrolling, never covering the page.
 *
 * Props: onBack, backLabel ('← Back to Home'), rightLabel + onRight (optional, e.g. 'Sign in')
 */
import React from 'react';

const btn = { background: 'transparent', border: '1px solid rgba(255,255,255,0.25)', color: '#E6F1FF', borderRadius: 8,
              padding: '8px 14px', fontSize: 14, cursor: 'pointer', whiteSpace: 'nowrap' };

const TopBar = ({ onBack, backLabel = '← Back to Home', rightLabel, onRight }) => (
  <div style={{ position: 'sticky', top: 0, zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                gap: 12, padding: '10px 16px', background: 'rgba(10, 22, 40, 0.92)', backdropFilter: 'blur(8px)',
                WebkitBackdropFilter: 'blur(8px)', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
    {onBack ? <button type="button" style={btn} onClick={onBack}>{backLabel}</button> : <span />}
    <span style={{ color: '#8892B0', fontSize: 14, fontWeight: 600, letterSpacing: 0.3 }}>Cetalingua FM</span>
    {rightLabel ? <button type="button" style={{ ...btn, borderColor: '#00B4D8', color: '#00B4D8' }} onClick={onRight}>{rightLabel}</button>
                : <span style={{ width: 1 }} />}
  </div>
);

export default TopBar;
